import { setCurrentBranch, setCurrentBranchCanPromote, setCurrentBranchNeedsUpdate } from 'app/branches/actions';
import { createBranchMutation } from 'app/branches/api';
import { createRoutine } from 'app/common/utils/new-routines';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import { showMessage } from 'app/messages/actions';
import type { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import { fetchSchemaRoutine } from './fetch-schema';

export const createBranchRoutine = createRoutine('branches/CREATE_BRANCH')<
  { name: string },
  undefined,
  undefined,
  undefined,
  string,
  undefined
>();

export function* createBranchSaga(payload: undefined, { name }: { name: string }): SagaIterator {
  return yield call(createBranchMutation, name);
}

export function* createBranchFulfilledSaga({
  meta: { name }
}: ActionType<typeof createBranchRoutine.fulfilled>): SagaIterator {
  yield put(setCurrentBranch({ branch: name }));
  yield put(setCurrentBranchNeedsUpdate(false));
  yield put(setCurrentBranchCanPromote(false));
  yield put(fetchSchemaRoutine.requested(undefined, { branch: name, runtime: false }));
}

export function* createBranchRejectedSaga({
  payload,
  meta: { name }
}: ActionType<typeof createBranchRoutine.rejected>): SagaIterator {
  console.error(`Failed to create branch "${name}":\n\n`, payload);
  yield put(showMessage('error', 'Failed to create branch. Please see dev console for more details.'));
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(createBranchRoutine.requested, getRoutineSaga(createBranchRoutine, createBranchSaga)),
    takeLatest(createBranchRoutine.fulfilled, createBranchFulfilledSaga),
    takeLatest(createBranchRoutine.rejected, createBranchRejectedSaga)
  ]);
}
